import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content__title" }
const _hoisted_2 = {
  key: 0,
  class: "content__description"
}
const _hoisted_3 = {
  key: 0,
  class: "SNotification__actions"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Продолжить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_s_gradients_provider = _resolveComponent("s-gradients-provider")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_chat_widget = _resolveComponent("chat-widget")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_s_gradients_provider),
    _createVNode(_component_notifications, {
      group: "create-module",
      width: "auto"
    }, {
      body: _withCtx((props) => [
        _createVNode("div", {
          class: ["SNotification", {
                    error: props.item.type === 'error',
                    ltl: props.item.type === 'ltl',
                    ftl: props.item.type === 'ftl',
                }]
        }, [
          _createVNode("div", {
            class: ["SNotification__content", { green: props.item.type === 'success' }]
          }, [
            _createVNode("p", _hoisted_1, _toDisplayString(props.item.title), 1),
            (props.item.text)
              ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(props.item.text), 1))
              : _createCommentVNode("", true)
          ], 2),
          (props.item.data.with_actions)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                (props.item.data.continue)
                  ? (_openBlock(), _createBlock(_component_s_button, {
                      key: 0,
                      class: {
                            primary:
                                !props.item.type ||
                                props.item.type === 'ltl' ||
                                props.item.type === 'primary',
                            red: props.item.type === 'ftl' || props.item.type === 'error',
                        },
                      onClick: props.item.data.continue
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode("p", {
                  class: "actions__cancel",
                  onClick: props.close
                }, "Отмена", 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }),
    _createVNode(_component_chat_widget, {
      "jira-id": "ccdccff6-6062-3fa1-b47a-f4a97b37c7e9",
      "service-desk-id": "6"
    })
  ], 64))
}